import {Article} from "./article.model";

export class Articles {
  items?: Article[];
  totalElements?: number;
  totalPages?: number
}
